import { AccessGate } from '../../shared/access/AccessControls';
import { useAllowedMutation, withAccess } from '../../shared/access/AccessControls';
import React, { useEffect } from 'react';
import { Button, Flex, Grid, Icon } from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tag, TagLabelType, TagType } from '../../shared/types/tag';
import { UpdateTagByIdRequest } from '../../store/responseTypes/tags';
import { tagsApi } from '../../store/services/TagsService';
import { mapableEnum } from '../../shared/utils/utils';
import FormInput from '../../shared/components/FormInput';
import FormSelect from '../../shared/components/FormSelect';
import FormButtonUpdate from '../../shared/components/FormButtonUpdate';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../router/routes';
import { AiOutlineClose } from 'react-icons/ai';
import AlertDialog from '../../shared/components/custom/AlertDialog/AlertDialog';
import { MLTag, MLTagType } from '../../shared/types/mediaLibraryTag';
import { UpdateMLTagByIdRequest } from '../../store/responseTypes/mediaLibraryTags';
import { mediaLibraryTagsApi } from '../../store/services/MediaLibraryTagsService';

interface ITagForm {
  tag: MLTag;
  setEdit: (T: boolean) => void;
}

const TagForm: React.FC<ITagForm> = ({ tag, setEdit }) => {
  const { register, handleSubmit, reset } = useForm<UpdateMLTagByIdRequest>();
  const navigate = useNavigate();
  const [updateTagById, { isLoading, isSuccess }] =
    useAllowedMutation(mediaLibraryTagsApi.useUpdateMlTagByIdMutation, 'updateMlTagById');
  const [deleteTag, { isLoading: isDeleting, isSuccess: isDeleted }] =
    useAllowedMutation(mediaLibraryTagsApi.useDeleteMlTagByIdMutation, 'deleteMlTagById');

  useEffect(() => {
    reset({
      label: tag.label,
      value: tag.value,
      type: tag.type,
    });
  }, [tag]);

  useEffect(() => {
    if (isSuccess) setEdit(false);
  }, [isSuccess]);

  useEffect(() => {
    if (isDeleted) navigate(Paths.tags);
  }, [isDeleted]);

  const onSubmit: SubmitHandler<UpdateMLTagByIdRequest> = async (data) => {
    await updateTagById({ tagId: tag.id, data });
  };

  const onDelete = () => {
    deleteTag(tag.id);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid rowGap={'1rem'} gridTemplateColumns={'1fr'}>
        <FormInput
          name={'label'}
          ph={'Label i18 (optional)'}
          register={register}
        />
        <FormInput name={'value'} ph={'Value'} register={register} />
        <FormSelect
          register={register}
          ph={'Type'}
          name={'type'}
          labeledOptions={[
            {
              label: 'Tag',
              value: MLTagType.TAG,
            },
            {
              label: 'Color',
              value: MLTagType.COLOR,
            },
          ]}
        />
        <Flex gridGap={'1rem'}>
          <AccessGate action="legacyFilerAdminOnly"><FormButtonUpdate isLoading={isLoading} /></AccessGate>
          <AccessGate action="legacyFilerAdminOnly"><AlertDialog
            title={`Are you sure you want to DELETE tag "${tag.value}"`}
            confirmLabel={'Delete'}
            confirmColorScheme={'red'}
            onConfirm={onDelete}
            activator={
              <Button colorScheme={'gray'} isLoading={isDeleting}>
                Delete
              </Button>
            }
          /></AccessGate>
        </Flex>
      </Grid>
    </form>
  );
};

export default withAccess(TagForm, 'legacyFilerAdminOnly');
